import { SideBarDef } from 'ag-grid-enterprise';
import { streamV2 } from '@services/context';
import { OrderDetailsPanel, OrderDetailsPanelProps } from './OrderDetailsPanel';
import { ToolPanel } from './useOrderDetailsPanel';
import { Order } from '@protos/v2/order';

export interface SidebarConfigOptions {
  includeColumns?: boolean;
  includeDetails?: boolean;
}

const defaultOptions: Required<SidebarConfigOptions> = {
  includeColumns: false,
  includeDetails: true,
};

export function createOrderDetailsSidebarConfig(
  orderPanelDetails: OrderDetailsPanelProps,
  visiblePanel: ToolPanel,
  options: SidebarConfigOptions = {}
): SideBarDef {
  const config = { ...defaultOptions, ...options };
  const toolPanels: SideBarDef['toolPanels'] = [];

  if (config.includeColumns) {
    toolPanels.push({
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    });
  }

  if (config.includeDetails) {
    toolPanels.push({
      id: 'details',
      labelDefault: 'Actions & Details',
      labelKey: 'details',
      iconKey: 'eye',
      toolPanel: OrderDetailsPanel,
      toolPanelParams: orderPanelDetails,
    });
  }

  return {
    toolPanels,
    defaultToolPanel: visiblePanel,
  };
}

export function createOrderPanelDetails(order: Order | null, cancelOrder?: (orderId: string) => void): OrderDetailsPanelProps {
  return {
    order,
    cancelOrder:
      cancelOrder ||
      ((orderId: string) => {
        streamV2.cancelOtcQuoteOrder(orderId);
      }),
  };
}
